import { NewsItem } from '../types'
import { SOURCES, GAMES } from '../config/sources'
import { formatDistanceToNow } from 'date-fns'
import { zhCN } from 'date-fns/locale'

interface Props {
  item: NewsItem
}

export default function NewsCard({ item }: Props) {
  const source = SOURCES[item.source]
  const game = GAMES[item.game]

  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString)
      return formatDistanceToNow(date, { addSuffix: true, locale: zhCN })
    } catch {
      return dateString
    }
  }

  return (
    <a
      href={item.url}
      target="_blank"
      rel="noopener noreferrer"
      className="news-card block bg-white rounded-xl overflow-hidden shadow-lg"
    >
      {item.images && item.images[0] && (
        <div className="h-48 overflow-hidden">
          <img
            src={item.images[0]}
            alt={item.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      )}
      
      <div className="p-5">
        <div className="flex items-center gap-2 mb-3">
          <span
            className="source-badge text-white"
            style={{ backgroundColor: source.color }}
          >
            {source.icon} {source.name}
          </span>
          <span
            className="source-badge text-white"
            style={{ backgroundColor: game.color }}
          >
            {game.icon} {game.name}
          </span>
          {item.isPinned && (
            <span className="px-2 py-1 rounded-full text-xs font-semibold bg-red-500 text-white">
              置顶
            </span>
          )}
        </div>

        <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
          {item.title}
        </h3>

        {item.summary && (
          <p className="text-gray-600 text-sm mb-3 line-clamp-3">
            {item.summary}
          </p>
        )}

        <div className="flex items-center justify-between text-sm text-gray-500">
          <div className="flex items-center gap-2">
            {item.author && (
              <span className="font-medium">{item.author}</span>
            )}
          </div>
          <time dateTime={item.publishTime}>
            {formatDate(item.publishTime)}
          </time>
        </div>

        {item.tags && item.tags.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-3">
            {item.tags.slice(0, 3).map((tag, index) => (
              <span
                key={index}
                className="px-2 py-1 rounded text-xs bg-gray-100 text-gray-600"
              >
                #{tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </a>
  )
}
